import React, { useEffect } from 'react';
import { TableTextLiterature } from '../../components';

const TextLiterature = () => {

  return (
    <div>
      <div className="m-2 md:m-10 p-2 md:p-6 bg-white rounded-3xl">
        <p className="text-xl mb-4 text-left">Lista e teksteve</p>
        <TableTextLiterature />
      </div>
    </div>
  );
};

export default TextLiterature;
